/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Vivid_Eagle_NoteInputs */

const en_wide_vivid_eagle_note = /** @type {(inputs: Wide_Vivid_Eagle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const de_wide_vivid_eagle_note = /** @type {(inputs: Wide_Vivid_Eagle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deaktiviert`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Wide_Vivid_Eagle_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_vivid_eagle_note = /** @type {((inputs?: Wide_Vivid_Eagle_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Vivid_Eagle_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_vivid_eagle_note(inputs)
	return de_wide_vivid_eagle_note(inputs)
});